<template>
  <homePage/>
</template>

<script>
import homePage from './components/home.vue'

export default {
  name: 'App',
  components: {
    homePage
  }
}
</script>

<style>
*{
  margin:0;
  padding:0;
}
</style>
